var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-approve-log-container" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-main",
          attrs: {
            title: "档案审批记录",
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "960px",
            top: "7vh",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeLog
          }
        },
        [
          _c(
            "div",
            { staticClass: "code-staff-search" },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "140px", "margin-right": "10px" },
                  attrs: { placeholder: "状态", size: "mini" },
                  on: { change: _vm.selectBindStatus },
                  model: {
                    value: _vm.getListParams.spStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.getListParams, "spStatus", $$v)
                    },
                    expression: "getListParams.spStatus"
                  }
                },
                _vm._l(_vm.statusOptions, function(item) {
                  return _c("el-option", {
                    key: item.bindStatus,
                    attrs: { label: item.label, value: item.bindStatus }
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "140px", "margin-right": "10px" },
                  attrs: { placeholder: "申请类型", size: "mini" },
                  on: { change: _vm.selectBindStatus2 },
                  model: {
                    value: _vm.getListParams.bindType,
                    callback: function($$v) {
                      _vm.$set(_vm.getListParams, "bindType", $$v)
                    },
                    expression: "getListParams.bindType"
                  }
                },
                _vm._l(_vm.applicationOptions, function(item) {
                  return _c("el-option", {
                    key: item.bindStatus,
                    attrs: { label: item.label, value: item.bindStatus }
                  })
                }),
                1
              ),
              _c(
                "el-tag",
                {
                  staticClass: "select-stafft-wrap",
                  attrs: {
                    title: "选择员工",
                    closable: _vm.searchMenNames.length === 0 ? false : true,
                    type: "medium",
                    effect: "plain"
                  },
                  on: {
                    close: _vm.searchCloseTag,
                    click: function($event) {
                      return _vm.clickAddMember()
                    }
                  }
                },
                [
                  _vm.searchMenNames.length === 0
                    ? _c("span", [_vm._v("选择员工")])
                    : _vm._e(),
                  _vm._l(_vm.searchMenNames, function(item, index) {
                    return _c(
                      "span",
                      { key: index, staticClass: "staff-names" },
                      [
                        _vm._v(_vm._s(item.name)),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.searchMenNames.length > 1 &&
                                  index != _vm.searchMenNames.length - 1,
                                expression:
                                  "searchMenNames.length>1&&index!=searchMenNames.length-1"
                              }
                            ]
                          },
                          [_vm._v(",")]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          [
            _c(
              "el-table",
              {
                ref: "cusChatTable",
                staticStyle: { "font-size": "13px" },
                attrs: {
                  size: "small",
                  data: _vm.tableData,
                  fit: "",
                  "highlight-current-row": "",
                  align: "center",
                  "header-cell-style": { background: "#F9F9F9" },
                  height: "calc(100vh - 180px - 14vh)"
                }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "客户", "min-width": "300" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0" },
                                      attrs: { span: 30 }
                                    },
                                    [
                                      _c("el-avatar", {
                                        attrs: {
                                          size: "medium",
                                          shape: "square",
                                          src: scope.row.avatar
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-col", { attrs: { span: 70 } }, [
                                    scope.row.ctmName != null
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "black" } },
                                          [_vm._v(_vm._s(scope.row.ctmName))]
                                        )
                                      : _c(
                                          "div",
                                          { staticStyle: { color: "black" } },
                                          [_vm._v("无绑定职称")]
                                        ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "#a09f9fc9",
                                          "font-size": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(_vm._s(scope.row.nickName)),
                                        scope.row.type == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "rgb(70, 189, 10)"
                                                }
                                              },
                                              [_vm._v(" @微信")]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "rgb(8, 168, 231)"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " @" +
                                                    _vm._s(scope.row.corpName)
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { label: "状态", "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            [
                              scope.row.spStatus == 1
                                ? _c("el-tag", { attrs: { size: "small" } }, [
                                    _vm._v("审批中")
                                  ])
                                : _vm._e(),
                              scope.row.spStatus == 2
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "success" }
                                    },
                                    [_vm._v("已通过")]
                                  )
                                : _vm._e(),
                              scope.row.spStatus == 3
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "danger" }
                                    },
                                    [_vm._v("已驳回")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { label: "申请类型", "min-width": "130" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.bindType == 1
                                    ? "档案绑定"
                                    : "档案解绑"
                                )
                              )
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyName",
                    label: "申请员工",
                    "min-width": "130"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyTime",
                    label: "提交时间",
                    "min-width": "150"
                  }
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          true
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "table-button",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleDetail(
                                        scope.$index,
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [_vm._v("详情")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          _c("Pagination", {
            attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
            on: { callBack: _vm.callBack }
          })
        ],
        2
      ),
      _c("StaffTree", {
        attrs: {
          title: "选择成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c("FileDetai", {
        attrs: { visiAble: _vm.detailVisiAble, detailItem: _vm.detailParams },
        on: { closeDetail: _vm.closeDetail }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }